export const apiDomain = process.env.ROOT_API;
export const frontDomain = process.env.FRONT_ROOT_URL;
export const ssoDomain = process.env.SSO_ROOT_URL;
export const s3_bucket_url = process.env.S3_BUCKET_URL;

export const autologinuser = apiDomain + '/autologinuser';


// WEBPACK FOOTER //
// ./src/config.js